import { request } from './client.js';
// ── Events (S1: create/edit/list/get + confirm/activate transitions) ───────
export async function listEvents(params) {
    const qs = params?.status ? `?status=${encodeURIComponent(params.status)}` : '';
    return request(`/admin/events${qs}`, { method: 'GET' });
}
export async function createEvent(input) {
    return request('/admin/events', { method: 'POST', body: input });
}
export async function getEvent(id) {
    return request(`/admin/events/${encodeURIComponent(id)}`, { method: 'GET' });
}
export async function updateEvent(id, input) {
    return request(`/admin/events/${encodeURIComponent(id)}`, {
        method: 'PATCH',
        body: input,
    });
}
/** draft → scheduled (R1.4) */
export async function confirmEvent(id) {
    return request(`/admin/events/${encodeURIComponent(id)}/confirm`, {
        method: 'POST',
    });
}
/** scheduled → active (R1.4) */
export async function activateEvent(id) {
    return request(`/admin/events/${encodeURIComponent(id)}/activate`, {
        method: 'POST',
    });
}
/** active → closed (S6, R6.1/R6.3/R6.4) */
export async function closeEvent(id, input = {}) {
    return request(`/admin/events/${encodeURIComponent(id)}/close`, {
        method: 'POST',
        body: input,
    });
}
/** S6, R6.2/R6.5 — read-only, only available once the event is closed. */
export async function getEventReport(id) {
    return request(`/admin/events/${encodeURIComponent(id)}/report`, {
        method: 'GET',
    });
}
/**
 * Operator-scoped GET /events/active (S4-UI prerequisite) — how the Flash
 * check-in screen lets an operator discover which event is currently active
 * before calling batch-checkin or guest-match, both of which need an
 * eventId. Deliberately a minimal summary, not the full admin EventResponse.
 */
export async function listActiveEvents() {
    return request('/events/active', { method: 'GET' });
}
// ── Event templates (R1.7/R1.8) ─────────────────────────────────────────────
export async function listEventTemplates() {
    return request('/admin/event-templates', { method: 'GET' });
}
export async function createEventTemplate(input) {
    return request('/admin/event-templates', {
        method: 'POST',
        body: input,
    });
}
//# sourceMappingURL=events.js.map